const File = [
  { type: 'item', disable: true, text: 'New Folder' },
  { type: 'separator' },
  { type: 'item', text: 'Close' },
];

const View = [
  { type: 'item', disable: true, text: 'Icons' },
  { type: 'item', disable: true, text: 'List' },
];

const Help = [
  { type: 'item', disable: true, text: 'About My Documents' },
];

export default { File, View, Help };
